export enum TipoAcessoExternoEnum
{
    "Pessoa Física Externa" = 1,
    "Destinatario" = 2
}